// 服务患者诊断信息
export const patientDiagnosisList = [
  {
    label: '诊断',
    key: 'diagnosisName'
  },
  {
    label: '处方药品',
    key: 'medicationName'
  }
]
